import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import cls from './header-dropdown.module.scss'

const defaultOffset = 12

/**
 * Универсальный выпадающий блок для десктопа.
 * Позиционируется относительно родителя (родитель должен быть position: relative).
 */
export const HeaderDropdown = ({
  isOpen,
  isLoading,
  onClose,
  children,
  className,
  width,
  offset = defaultOffset,
  align = 'left',
  maxHeight,
  onScroll,
}) => {
  const dropdownRef = useRef(null)

  useEffect(() => {
    if (!isOpen) return undefined

    const handleClickOutside = event => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !dropdownRef.current.parentElement.contains(event.target)
      ) {
        onClose?.()
      }
    }

    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        onClose?.()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div
      ref={dropdownRef}
      className={classNames(cls.dropdown, className, {
        [cls.alignCenter]: align === 'center',
        [cls.alignRight]: align === 'right',
        [cls.borderAnimation]: isLoading,
      })}
      style={{
        marginTop: offset,
        width,
        maxHeight,
      }}
      role="dialog"
      onScroll={onScroll}
    >
      {children}
    </div>
  )
}

HeaderDropdown.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  offset: PropTypes.number,
  align: PropTypes.oneOf(['left', 'center', 'right']),
}
